var map = {
	"./ar/sound/SoundPage.vue": [
		3283,
		3581,
		3283
	],
	"./bn/sound/SoundPage.vue": [
		8037,
		3581,
		8037
	],
	"./en/sound/SoundPage.vue": [
		6861,
		3581,
		6861
	],
	"./fa/sound/SoundPage.vue": [
		6995,
		3581,
		6995
	],
	"./ur/sound/SoundPage.vue": [
		7707,
		3581,
		7707
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 5848;
module.exports = webpackAsyncContext;